module.exports = __webpack_public_path__ + "static/img/gr.471d733a.svg";